import { useMemo } from "react";
import { FlatfileClient } from "@flatfile/api";
import { IBulkBatch } from "@wingspanhq/payments/dist/interfaces";
import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";

/**
 * Flatfile API client authenticated with the space access token the Flatfile listener stored on
 * the batch labels.
 *
 * Returns undefined for batches without a Flatfile space (API uploads) or when the space access
 * token is not available (yet).
 */
export function useFlatfileApiClient(
  bulkBatch?: IBulkBatch
): FlatfileClient | undefined {
  const accessToken = bulkBatch?.labels?.[
    BATCH_LABELS_WS_KEYS.flatfileAccessToken
  ] as string | undefined;

  return useMemo(
    () =>
      accessToken ? new FlatfileClient({ token: accessToken }) : undefined,
    [accessToken]
  );
}
